import type { SC007UploadImportDocumentPayload } from '@app/types/sc007';

/**
 * Builds the multipart/form-data body for API-SC007-08 (POST /api/document/import-document).
 * The form data includes:
 * - A JSON blob named 'importDocumentRequests' containing the metadata and document info.
 * - One or more file entries named 'files[]' for the actual document files.
 */
export function buildImportDocumentFormData(payload: SC007UploadImportDocumentPayload): FormData {
  const formData = new FormData();

  const payloadBlob = new Blob([JSON.stringify(payload?.importDocumentRequests)], {
    type: 'application/json',
  });
  formData.set('importDocumentRequests', payloadBlob);

  // File entry → Content-Disposition: form-data; name="files[]"; filename="<name>"
  //               Content-Type: <file.type>
  payload.files.forEach((file) => {
    formData.append('files[]', file, file.name);
  });

  return formData;
}
